module.exports = __webpack_public_path__ + "static/media/dana2.5c8eb6c3.jpg";